// extracted by mini-css-extract-plugin
export default {"loading-cell":"loading-cell_loading-cell__oZ1vY","loading-cell__skeleton":"loading-cell_loading-cell__skeleton__aCG-j"};